import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyleBox = styled(Box)(({ theme }) => ({
  '& .LFSearchInputContainer': {
    background: theme.palette.secondary.dark,
    backdropFilter: `blur(${theme.spacing(1)})`,
    display: 'flex',
    height: theme.spacing(5.75),
  },

  '& .LFSearchBtn': {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0, 0.5, 0.5, 0),
    background: `linear-gradient(180deg, ${alpha(
      theme.palette.common.white,
      0.1,
    )} 0%,  ${alpha(theme.palette.common.white, 0)}100%), ${
      theme.palette.primary.main
    }`,
    boxShadow: `0px 2px 2px 0px ${alpha(
      theme.palette.common.white,
      0.25,
    )} inset, 0px -2px 2px 0px ${alpha(theme.palette.common.black, 0.1)} inset`,
    color: theme.palette.common.black,
    fontSize: theme.spacing(3),
  },
  '& .LFInput': {
    '& .MuiInputBase-root': {
      borderRadius: theme.spacing(0.5, 0, 0, 0.5),
    },
    '& .MuiInputBase-input': {
      padding: theme.spacing(1.75, 2, 1.5, 2),
      fontSize: theme.spacing(1.75),
      lineHeight: theme.spacing(1.75),
      color: theme.palette.common.white,
    },
    '& fieldset': {
      borderRight: 0,
    },
    '& input::placeholder': {
      color: theme.palette.common.white,
      opacity: 1,
    },
  },
  '& .LFFilterButton': {
    border: `1px solid ${theme.palette.divider[1]}`,
    backgroundColor: theme.palette.secondary.main,
    width: theme.typography.pxToRem(48),
    height: theme.typography.pxToRem(46),
    padding: theme.spacing(1.875, 2),
    fontSize: theme.spacing(2),
    color: theme.palette.common.white,
  },
}));
export default StyleBox;
